export default {
  items: [
    {
      name: 'Dashboard',
      code: 'common',
      active_yn: 'Y',
      url: '/dashboard',
      icon: 'icon-speedometer',
    },
    {
      title: true,
      code: 'common',
      active_yn: 'Y',
      name: '',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: '회원관리',
      code: 'ACCESS_MENU_1',
      active_yn: 'N',
      url: '/user',
      icon: 'fa fa-user-o fa-lg',
      children: [
        {
          name: '전체회원',
          url: '/user/manage',
        },
        {
          name: '구독회원',
          // url: '/user/authusermanage',
          url: '/user/companyusermanage',
        },
        // {
        //   name: '[X] R-Point 관리',
        //   url: '/user/rpoint',
        // },
      ]
    },
    {
      name: '콘텐츠관리',
      code: 'ACCESS_MENU_2',
      active_yn: 'N',
      url: '/contents',
      icon: 'fa fa-newspaper-o fa-lg',
      children: [
        // {
        //   name: '트렌드브리프 관리',
        //   url: '/contents/trendbrief',
        // },
        // {
        //   name: '인뎁스리포트 관리',
        //   url: '/contents/indepthreport',
        // },
        // {
        //   name: '서베이리포트 관리',
        //   url: '/contents/surveyreport',
        // },
        // {
        //   name: '비주얼브리프 관리',
        //   url: '/contents/visualbrief',
        // },
        {
          name: 'DMC보고서',
          url: '/contents/list',
        },
        // {
        //   name: '콘텐츠 등록',
        //   url: '/contents/form',
        // },
        {
          name: '외부보고서',
          url: '/contents/extList',
        },
        {
          name: '외부 뉴스',
          url: '/contents/extNews',
        },
        {
          name: '외부수집 설정',
          url: '/contents/extSiteSettings',
        },
        {
          name: '리포트 서베이 관리',
          url: '/contents/reportSurveyManagement',
        },
        // {
        //   name: '종합보고서 관리',
        //   url: '/temp/page',
        // },
      ]
    },
    {
      name: '상품관리',
      code: 'ACCESS_MENU_5',
      active_yn: 'N',
      url: '/product',
      icon: 'fa fa-gift fa-lg',
      children: [
        {
          name: '패키지',
          url: '/product/annualreport',
        },
        {
          name: '구독상품',
          url: '/product/userauthpermission',
        },
        {
          name: '종합보고서',
          url: '/product/synthesisreport',
        },
      ]
    },
    {
      name: '주문관리',
      code: 'ACCESS_MENU_3',
      active_yn: 'N',
      url: '/order',
      icon: 'fa fa-shopping-basket fa-lg',
      children: [
        {
          name: '보고서상품 주문',
          url: '/order/product',
        },
        {
          name: '구독회원 주문',
          url: '/order/userAuth',
        },
      ]
    },
    {
      name: '고객센터관리',
      code: 'ACCESS_MENU_10',
      active_yn: 'N',
      url: '/customer',
      icon: 'fa fa-headphones fa-lg',
      children: [
        {
          name: '공지사항',
          url: '/customer/notice',
        },
        {
          name: '고객문의',
          url: '/customer/qamanager',
        },
        // {
        //   name: '고객문의(비로그인)',
        //   url: '/customer/qamanagerpublic',
        // },
        {
          name: '보고서 의뢰',
          url: '/customer/reportrequestpublic',
        },
        {
          name: 'FAQ',
          url: '/customer/faqmanager',
        },
        // {
        //   name: '회원가입안내',
        //   url: '/customer/joinguide',
        // },
        {
          name: '답변 템플릿',
          url: '/customer/qatemplate',
        },
      ]
    },
    {
      name: '쿠폰관리',
      code: 'ACCESS_MENU_4',
      active_yn: 'N',
      url: '/coupon',
      icon: 'fa fa-money fa-lg',
      children: [
        {
          name: '쿠폰관리',
          url: '/coupon/manage',
        },
        // {
        //   name: '쿠폰 발급 관리',
        //   url: '/temp/page',
        // },
      ]
    },
    // {
    //   name: '[X]대시보드(메인)관리',
    //   url: '/main',
    //   icon: 'fa fa-television fa-lg',
    //   children: [
    //     {
    //       name: '메인 관리',
    //       url: '/main/mainmanagement',
    //     },
    //     {
    //       name: '배너 관리',
    //       url: '/main/bannermanagement',
    //     },
    //   ]
    // },
    {
      name: '사이트 관리',
      code: 'ACCESS_MENU_8',
      active_yn: 'N',
      url: '/site',
      icon: 'fa fa-television fa-lg',
      children: [
        {
          name: '메인페이지',
          url: '/site/mainmanagement',
        },
        {
          name: '팝업',
          url: '/site/popupmanagement',
        },
        {
          name: '약관',
          url: '/site/termsmanagement',
        },
        {
          name: '통합검색',
          url: '/site/searchmanagement',
        },
      ]
    },
    {
      name: '레터관리',
      code: 'ACCESS_MENU_6',
      active_yn: 'N',
      url: '/letter',
      icon: 'fa fa-sticky-note-o fa-lg',
      children: [
        {
          name: '뉴스레터',
          url: '/letter/newsletter',
        },
      ]
    },
    {
      name: '통계관리',
      code: 'ACCESS_MENU_7',
      active_yn: 'N',
      url: '/statis',
      icon: 'fa fa-pie-chart fa-lg',
      children: [
        {
          name: '회원 통계',
          url: '/statis/userStatistics',
        },
        {
          name: '콘텐츠 통계(일반)',
          url: '/statis/contentStatistics',
        },
        {
          name: '콘텐츠 통계(스페셜)',
          url: '/statis/contentArStatistics',
        },
        {
          name: '매출 통계',
          url: '/statis/salesStatistics',
        }, {
          name: '외부수집 통계',
          url: '/statis/extSiteStatistics',
        },
      ]
    },
    {
      name: '공통관리',
      code: 'ACCESS_MENU_11',
      active_yn: 'N',
      url: '/common',
      icon: 'fa fa-hashtag fa-lg',
      children: [
        {
          name: '코드',
          url: '/common/code',
        },
        // {
        //   name: '메뉴',
        //   url: '/common/menu',
        // },
        {
          name: '관리자',
          url: '/common/manager',
        },
        {
          name: '개인정보접근이력',
          url: '/common/privacy',
        },
        {
          name: '로그인 이력',
          url: '/common/loginlog',
        }
      ]
    },
    {
      name: '관리자 공지사항',
      code: 'common',
      active_yn: 'Y',
      url: '/manager',
      icon: 'fa fa-hashtag fa-lg',
      children: [
        {
          name: '관리자공지사항',
          url: '/manager/noticemanagement',
        },
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js